import { useTranslation } from 'react-i18next';

import { Heading1, Stack } from '@myphx-engineering/phx-design-system';

import { ComparePricesCard } from '../../components/start-saving/ComparePricesCard';
import { Steps } from '../../components/start-saving/Steps';

const StartSavingRoute = () => {
    const { t } = useTranslation();

    return (
        <Stack gap="xl">
            <Stack gap="lg">
                <Heading1>{t('startSavingPage.title')}</Heading1>
                <Steps />
            </Stack>
            <ComparePricesCard />
        </Stack>
    );
};

export default StartSavingRoute;
